import ky from 'ky';

import {
  logRequestId,
  addHeadersAuthenticationHook,
  refreshTokenHook,
  beforeErrorHook,
} from '@campaign/utils/api-hooks';

export const api = ky.create({
  hooks: {
    afterResponse: [logRequestId],
    beforeError: [beforeErrorHook],
    beforeRequest: [addHeadersAuthenticationHook],
    beforeRetry: [refreshTokenHook],
  },
  retry: {
    backoffLimit: 3000,
    limit: 2,
    methods: ['get', 'post', 'patch', 'delete'],
    statusCodes: [401],
  },
});

export const apiWithoutAuthentication = ky.create({
  hooks: {
    afterResponse: [logRequestId],
    beforeError: [beforeErrorHook],
  },
});
